import React, { useContext, useState } from "react";
import { Bundle } from "src/types/global";
import { Button, Drawer, message } from "antd";
import MCounter from "../cart/MCounter";
import { formatPrice, getAuthToken, handleLogin } from "Utils/common";
import { getSelectedSTObj } from "Utils/addressUtils";
import axios from "axios";
import { addToCartErrorHandle } from "Utils/activityHelper";
import { cartAddUrl } from "Utils/constant";
import { AppContext } from "Store";
import { logOperation } from "Utils/operationLogUtils";
import MBunldeCard from "./MBundleCard";
import Limitations from "Components/common/Limitation";
import checkedImg from "Images/checkedIcon.svg";
import { RightOutlined } from "@ant-design/icons";
import { addToCartDataPush } from "Utils/analyticsUtils";

const MBundleList = ({
  bundles,
  currentBundle,
  setCurrentBundle,
  activityId,
  previewFlag,
  onAddToCart,
}: {
  bundles: Bundle[];
  currentBundle: Bundle | undefined;
  setCurrentBundle: Function;
  activityId: string | undefined;
  previewFlag: boolean;
  onAddToCart?: Function;
}) => {
  const { checkedCartItems, setCheckedCartItems, setCartCount, loginState } =
    useContext(AppContext);
  const [shoppingQty, setShoppingQty] = React.useState<number>(0);
  const [processing, setProcessing] = useState<boolean>(false);
  const [drawerVisible, setDrawerVisible] = useState<boolean>(false);
  const toggleDrawer = () => {
    setDrawerVisible(!drawerVisible);
  };
  if (!bundles || bundles.length === 0) return null;
  if (!currentBundle) return null;
  return (
    <>
      <div className="filterWrapper1">
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "12px",
            padding: "12px 15px 10px 15px",
            fontSize: "14px",
          }}
        >
          <button className={"categoryMenu active"} style={{ borderRadius: "6px" }}>
            <span
              dangerouslySetInnerHTML={{
                __html: currentBundle.tieredName,
              }}
            ></span>
          </button>
          {bundles.length > 1 && (
            <span onClick={toggleDrawer} style={{
              fontSize: "14px",
              color: "#54545c",
            }}>
              <span>查看更多套装 ({bundles.length - 1}套) </span>
              <RightOutlined />
            </span>
          )}
        </div>
        <div
          className="desc"
          style={{
            fontSize: "13px",
            fontWeight: 400,
            color: "#1b1b1d",
            padding: "0 15px 10px 15px",
          }}
        >
          {currentBundle?.tieredDescription}
        </div>
      </div>
      <MBunldeCard bundle={currentBundle} previewFlag={previewFlag} activityId={activityId} />
      <div className="bundleCardFooter">
        <div className="footerContent">
          {currentBundle.status === "Preview" ? (
            <div
              style={{
                color: "#70707a",
              }}
            >
              敬请期待
            </div>
          ) : (
            <div>
              <span>总价</span>
              <span
                style={{
                  paddingLeft: "12px",
                  fontSize: "18px",
                  color: "#1b1b1d",
                }}
              >
                {formatPrice(currentBundle.bundleTotal)}
              </span>
            </div>
          )}
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <div
              style={{
                padding: "10px 0 4px 0",
                textAlign: "right",
              }}
            >
              <MCounter
                type="bundle"
                login={loginState?.status === "login"}
                bundle={currentBundle}
                value={currentBundle.minBundle}
                resetCount={0}
                onChange={(qty) => {
                  setShoppingQty(qty);
                }}
                product={{
                  shoppingQty: currentBundle.minBundle,
                  min: currentBundle.minBundle,
                  max: currentBundle.maxBundle,
                  priceStatus: previewFlag,
                }}
              />
              <div
                style={{
                  fontSize: "11px",
                  paddingTop: "2px",
                  color: "#e71316",
                }}
              >
                <Limitations tieredRule={currentBundle} comma={true} />
              </div>
            </div>
            <span style={{ paddingLeft: "12px" }}>
              <Button
                className="shoppingBtn"
                disabled={previewFlag}
                onClick={(e) => {
                  console.log("shopping button clicked", shoppingQty);
                  console.log("add to cart");
                  if (loginState?.status !== "login") {
                    handleLogin();
                    return;
                  }
                  const quantity = shoppingQty || currentBundle.minBundle;
                  if (!quantity) return;
                  if (processing) return;
                  setProcessing(true);
                  e.stopPropagation();
                  const selectedST = getSelectedSTObj(loginState);
                  axios(cartAddUrl, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: getAuthToken(),
                    },
                    data: {
                      activityId: activityId,
                      type: "activity",
                      category: currentBundle.tieredName,
                      quantity: quantity,
                      customerStNumber: selectedST?.accountNumber,
                    },
                  })
                    .then((resp) => {
                      console.log("add to cart", resp);
                      const respData = resp.data;
                      if (respData?.status === "success") {
                        message.success("已加入购物车");
                        const count = respData?.data?.cartCount || 0;
                        checkedCartItems.add(currentBundle.id);
                        setCheckedCartItems(new Set(checkedCartItems));
                        setCartCount(count);
                        onAddToCart && onAddToCart();
                        addToCartDataPush({

                        })
                        setProcessing(false);
                        const cartObj = {
                          cartId: activityId
                        };
                        const fprice = Number(currentBundle.bundleTotal.toFixed(2));
                        addToCartDataPush({
                          cartObj,
                          placement: "marketing_detail",
                          method: "product_card",
                          products: [{
                            name: currentBundle.tieredName,
                            catalogId: `marketing_bundle_${currentBundle.id}`,
                            quantity: quantity,
                            price: fprice ? (fprice * quantity).toFixed(2) : "0",
                          }]
                        });
                        return;
                      }
                      addToCartErrorHandle(respData, message, "bundle", "pc");
                      setProcessing(false);
                    })
                    .catch((err) => {
                      console.log("add to cart error", err);
                      setProcessing(false);
                      message.error(
                        "加入购物车失败, 可能是该产品不支持在线下单，如果问题持续，请联系客服"
                      );
                    });
                  logOperation({
                    opUser: loginState?.user?.user?.userId,
                    opTarget: "Add_To_Cart",
                    opTargetId: currentBundle.tieredName,
                    opContent: "Activity_Detail",
                  });
                }}
              >
                一键加购
              </Button>
            </span>
          </div>
        </div>
      </div>
      <Drawer
        open={drawerVisible}
        placement="bottom"
        height={"68vh"}
        onClose={toggleDrawer}
        className="bundleCheckListDrawer"
      >
        {drawerVisible && (
          <BundleCheckList
            bundles={bundles}
            currentBundle={currentBundle}
            setCurrentBundle={setCurrentBundle}
            toggleDrawer={toggleDrawer}
          />
        )}
      </Drawer>
    </>
  );
};
const BundleCheckList = ({
  bundles,
  currentBundle,
  setCurrentBundle,
  toggleDrawer,
}: {
  bundles: Bundle[];
  currentBundle: Bundle;
  setCurrentBundle: Function;
  toggleDrawer: Function;
}) => {
  const [checkedBundle, setCheckedBundle] = useState<Bundle>(currentBundle);
  return (
    <>
      <div className="bundleCheckList">
        {bundles.map((bundle) => {
          const isChecked = checkedBundle.id === bundle.id;
          return (
            <div
              className="checkItem"
              onClick={() => {
                setCheckedBundle(bundle);
              }}
            >
              <label
                key={bundle.id}
                className={`${isChecked ? "checked" : ""}`}
                dangerouslySetInnerHTML={{ __html: bundle.tieredName }}
              ></label>
              {isChecked ? <img src={checkedImg} alt="checked"></img> : null}
            </div>
          );
        })}
      </div>
      <div className="checklistFooter">
        <Button
          style={{
            width: "100%",
            height: "44px",
            fontSize: "16px",
            fontWeight: 400,
            color: "#fff",
            backgroundColor: "#e71316",
            borderRadius: "3px",
          }}
          onClick={() => {
            toggleDrawer();
            setCurrentBundle(checkedBundle);
          }}
        >
          确认
        </Button>
      </div>
    </>
  );
};

export default MBundleList;
